export const getMaxNumber = (arr: number[]): number =>
  arr.reduce((max, current) => {
    if (max === null) {
      return current;
    }

    return current > max ? current : max;
  }, null);
